import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var CandlestickFinder =
/*#__PURE__*/
function () {
  function CandlestickFinder() {// if (new.target === Abstract) {
    //     throw new TypeError("Abstract class");
    // }

    _classCallCheck(this, CandlestickFinder);
  }

  _createClass(CandlestickFinder, [{
    key: "approximateEqual",
    value: function approximateEqual(a, b) {
      var left = parseFloat(Math.abs(a - b).toPrecision(4)) * 1;
      var right = parseFloat((a * 0.001).toPrecision(4)) * 1;
      return left <= right;
    }
  }, {
    key: "logic",
    value: function logic(data) {
      throw new Error("this has to be implemented");
    }
  }, {
    key: "getAllPatternIndex",
    value: function getAllPatternIndex(data) {
      var _this = this;

      if (data.close.length < this.requiredCount) {
        console.warn("Data count less than data required for the strategy ", this.name);
        return [];
      }

      if (data.reversedInput) {
        data.open.reverse();
        data.high.reverse();
        data.low.reverse();
        data.close.reverse();
      }

      var strategyFn = this.logic;
      return this._generateDataForCandleStick(data).map(function (current, index) {
        return strategyFn.call(_this, current) ? index : undefined;
      }).filter(function (hasIndex) {
        return hasIndex;
      });
    }
  }, {
    key: "hasPattern",
    value: function hasPattern(data) {
      if (data.close.length < this.requiredCount) {
        console.warn("Data count less than data required for the strategy ", this.name);
        return false;
      }

      if (data.reversedInput) {
        data.open.reverse();
        data.high.reverse();
        data.low.reverse();
        data.close.reverse();
      }

      var strategyFn = this.logic;
      return strategyFn.call(this, this._getLastDataForCandleStick(data));
    }
  }, {
    key: "_getLastDataForCandleStick",
    value: function _getLastDataForCandleStick(data) {
      var requiredCount = this.requiredCount;

      if (data.close.length === requiredCount) {
        return data;
      } else {
        var returnVal = {
          open: [],
          high: [],
          low: [],
          close: []
        };
        var i = 0;
        var index = data.close.length - requiredCount;

        while (i < requiredCount) {
          returnVal.open.push(data.open[index + i]);
          returnVal.high.push(data.high[index + i]);
          returnVal.low.push(data.low[index + i]);
          returnVal.close.push(data.close[index + i]);
          i++;
        }

        return returnVal;
      }
    }
  }, {
    key: "_generateDataForCandleStick",
    value: function _generateDataForCandleStick(data) {
      var requiredCount = this.requiredCount;
      var generatedData = data.close.map(function (currentData, index) {
        var i = 0;
        var returnVal = {
          open: [],
          high: [],
          low: [],
          close: []
        };

        while (i < requiredCount) {
          returnVal.open.push(data.open[index + i]);
          returnVal.high.push(data.high[index + i]);
          returnVal.low.push(data.low[index + i]);
          returnVal.close.push(data.close[index + i]);
          i++;
        }

        return returnVal;
      }).filter(function (val, index) {
        return index <= data.close.length - requiredCount;
      });
      return generatedData;
    }
  }]);

  return CandlestickFinder;
}();

export { CandlestickFinder as default };